export const testimonials = [
  {
    name: "Afaaq",
    image: "/afaaq.jpg",
    review:
      "AI Lab has completely transformed how I work. The platform is intuitive, fast, and offers possibilities for creating a custom blog app without any coding. Highly recommend it to anyone looking to automate tasks effectively!",
    title: "Transformed the way I work",
    rating: 5,
  },
  {
    name: "Usama",
    image: "/Usama.jpg",
    review:
      "What I love most about AI Lab is its ease of use and versatility. It has saved me hours of manual work each week, and the results are always spot on. It's a must-have tool for professionals!",
    title: "Saved me hours of manual work",
    rating: 5,
  },
  {
    name: "Tehreem",
    image: "/Tahreem.jpg",
    review:
      "AI Lab is a game-changer with outstanding features that make work effortless and efficient. The platform consistently delivers high performance, and its technology ensures reliability even during peak usage.",
    title: "Game-changer",
    rating: 4,
  },
  {
    name: "Ramsha",
    image: "/Ramsha.jpg",
    review:
      "This platform is a lifesaver! It simplifies complex tasks into a few clicks and helps me focus on the bigger picture. The automation tools are brilliant, and I can’t imagine working without it anymore!",
    title: "Life saver",
    rating: 5,
  },
  {
    name: "Ayesha",
    image: "/Ayesha.jpg",
    review:
      "AI Lab is a fantastic app with immense potential. I would love to see a feature that allows for building an AI Blog app, capable of checking recent updates from the internet and generating blog posts based on the latest news. This would add even more value to an already powerful platform!",
    title: "Fantastic app, but could be more",
    rating: 3,
  },
  {
    name: "Awais",
    image: "/awais.png",
    review:
      "I am beyond impressed with AI Lab. It’s user-friendly, efficient, and makes creating AI-powered solutions feel effortless. Whether you're tech-savvy or not, this app is for everyone!",
    title: "Effortless AI solutions",
    rating: 5,
  },
];
